export class AddCodesRequestComponent {
    constructor(public promotionKey: string,
                public promotionType: string,
                public numeroCodigos: number) {
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/ganalottodo/add-codes-request-component.ts